import React from 'react';
import PropTypes from 'prop-types';

import { RouteModal } from 'catering/components/Modals';

import { useGoToMenuScreen } from 'catering/hooks/navigation';
import { WHITE } from 'styles/theme/colors';

function MenuItemDetailsModal({ menuItemDetails, menuItemDetailsForm }) {
  const goToMenuScreen = useGoToMenuScreen();

  const { imageSrc } = menuItemDetails;

  const hasImage = !!imageSrc;

  return (
    <RouteModal
      onClose={goToMenuScreen}
      ModalDismissButtonProps={{
        color: hasImage ? WHITE : 'default'
      }}
    >
      {menuItemDetailsForm}
    </RouteModal>
  );
}

MenuItemDetailsModal.propTypes = {
  menuItemDetails: PropTypes.object.isRequired,
  menuItemDetailsForm: PropTypes.element.isRequired
};

export default MenuItemDetailsModal;
